import { DocumentsActionTypes } from './constants';

const INIT_STATE = {
    data: null,
    loading: false,
    error: null,
    createSuccess: null,
    updateSuccess: null,
};

/**
 * Single Document reducer
 */
const Document = (state = INIT_STATE, action) => {
    switch (action.type) {
        case DocumentsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case DocumentsActionTypes.GET_DOCUMENT:
                    return { ...state, data: action.payload.data, loading: false };

                case DocumentsActionTypes.CREATE_DOCUMENT:
                    return {
                        ...state,
                        data: action.payload.data,
                        loading: false,
                        createSuccess: true,
                    };

                case DocumentsActionTypes.UPDATE_DOCUMENT:
                    return {
                        ...state,
                        data: action.payload.data,
                        loading: false,
                        updateSuccess: true,
                    };

                case DocumentsActionTypes.DELETE_DOCUMENT:
                    return { ...state, data: action.payload.data, loading: false };

                default:
                    return { ...state };
            }

        case DocumentsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case DocumentsActionTypes.GET_DOCUMENT:
                    return { ...state, error: action.payload, loading: false };

                case DocumentsActionTypes.CREATE_DOCUMENT:
                    return { ...state, error: action.payload, loading: false, createSuccess: false };

                case DocumentsActionTypes.UPDATE_DOCUMENT:
                    return { ...state, error: action.payload, loading: false, updateSuccess: false };

                case DocumentsActionTypes.DELETE_DOCUMENT:
                    return { ...state, error: action.payload, loading: false };

                default:
                    return { ...state };
            }

        // Get a single document
        case DocumentsActionTypes.GET_DOCUMENT:
            return { ...state, data: null, loading: true };

        // Create a document
        case DocumentsActionTypes.CREATE_DOCUMENT:
            return { ...state, data: null, createSuccess: false, loading: true };

        // Update a document
        case DocumentsActionTypes.UPDATE_DOCUMENT:
            return { ...state, updateSuccess: false, loading: true };

        default:
            return { ...state };
    }
};

/**
 * Documents collection reducer
 */
const Documents = (state = INIT_STATE, action) => {
    switch (action.type) {
        case DocumentsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case DocumentsActionTypes.GET_DOCUMENTS:
                    return { ...state, data: action.payload.data, loading: false };

                case DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTION:
                    return { ...state, data: action.payload.data, loading: false };

                case DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTIONS:
                    return { ...state, data: action.payload.data, loading: false };    

                case DocumentsActionTypes.GET_DOCUMENTS_BY_LISTING:
                    return { ...state, data: action.payload.data, loading: false };

                case DocumentsActionTypes.GET_DOCUMENTS_BY_OWNER:
                    return { ...state, data: action.payload.data, loading: false };

                default:
                    return { ...state };
            }

        case DocumentsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case DocumentsActionTypes.GET_DOCUMENTS:
                case DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTION:
                case DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTIONS:
                case DocumentsActionTypes.GET_DOCUMENTS_BY_LISTING:
                case DocumentsActionTypes.GET_DOCUMENTS_BY_OWNER:
                    return { ...state, error: action.payload, loading: false };

                default:
                    return { ...state };
            }

        // Get documents
        case DocumentsActionTypes.GET_DOCUMENTS:
            return { ...state, loading: true };

        case DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTION:
            return { ...state, loading: true };

        case DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTIONS:
            return { ...state, loading: true };

        case DocumentsActionTypes.GET_DOCUMENTS_BY_LISTING:
            return { ...state, loading: true };

        case DocumentsActionTypes.GET_DOCUMENTS_BY_OWNER:
            return { ...state, loading: true };

        default:
            return { ...state };
    }
};

export { Document, Documents };